module.exports = __webpack_public_path__ + "images/spider-man_rgba(0,0,0,0.7).jpg?v=456a3359517aa4e2fc6b2e2d6fb8b10f";